module.exports = __webpack_public_path__ + "assets/img/block-right-hover-018b0b34.png";